export const projects = [
  {
    name: "BAZER FARMING",
    link: "https://t.me/BazerFarming_bot",
    bot: "@BazerFarming_bot",
  },
  {
    name: "BAZER EXCHANGE",
    link: "https://t.me/bazerp2p_bot",
    bot: "@bazerp2p_bot",
  },
  {
    name: "BAZER STAKING WALLET",
    link: "https://t.me/Bazer_stake_bot",
    bot: "@Bazer_stake_bot",
  },
];